module.exports = __webpack_public_path__ + "img/yes.9c514eb4.png";